import type { ClientMediaItem } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, useMemo, type FC } from 'react';
import { StyleSheet, View } from 'react-native';

import { MediaImageSized } from '@/features/media/components/MediaImageSized';
import { MediaItemSize } from '@/features/media/types/mediaItem';
import { FixedSizeCarousel } from '@/shared/components/carousel/FixedSizeCarousel';
import type { CarouselLayoutSize } from '@/shared/types/carousel';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

type Props = {
  images: ClientMediaItem[];
};

export const TerritorialAuthorityImageCarousel: FC<Props> = ({ images }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const renderItem = useCallback(
    (image: ClientMediaItem, layout: CarouselLayoutSize) => (
      <MediaImageSized
        style={layout}
        mediaItem={image}
        mediaSize={MediaItemSize.MEDIUM}
      />
    ),
    []
  );

  return (
    <View style={styles.wrapper}>
      <FixedSizeCarousel data={images} renderItem={renderItem} itemGap={16} />
    </View>
  );
};

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    wrapper: {
      height: 292,
      backgroundColor: theme.colors.surfaceContainerLowest
    }
  });
